// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SizeMonitor_wrapper__3jM3b","active":"SizeMonitor_active__3HPgQ","inner":"SizeMonitor_inner__3zq38"};